import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../App";
import Navigation from "../../components/Layouts/Header/Navigation";

import AuctionDetails from "../../components/StarShowcase/Auction/Content/AuctionDetails";

const Auction = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [loader, setLoader] = useState(true);

  const [AuctionProduct, setProduct] = useState([]);

  useEffect(() => {
    const product_id = props.match.params.product_id;

    axios.get(`/api/user/getStarAuctionProduct/${product_id}`).then((res) => {
      if (res.data.status === 200) {
        setProduct(res.data.product);
      }
      setLoader(false);
    });
  }, [props.match.params.product_id]);

  return (
    <>
      <Navigation />

      {loader ? (
        <center className="mb-5 mt-5">
          <div
            class="spinner-border text-warning"
            role="status"
            style={{ height: 50, width: 50 }}
          >
            <span class="sr-only">Loading...</span>
          </div>
        </center>
      ) : (
        <div className="container mt-3">
          {AuctionProduct.map((product) => (
            <>
              <img
                src={imageCdnUrl + product.banner}
                className="img-fluid w-100 CR7Cover "
                alt=""
                style={{ maxHeight: "500px" }}
              />
              <div className="row justify-content-between">
                <AuctionDetails key={product.id} data={product} />
              </div>
            </>
          ))}
        </div>
      )}
    </>
  );
};

export default Auction;
